import { render, staticRenderFns } from "./correct4.vue?vue&type=template&id=7697e83d&scoped=true"
import script from "./correct4.vue?vue&type=script&lang=js"
export * from "./correct4.vue?vue&type=script&lang=js"
import style0 from "./correct4.vue?vue&type=style&index=0&id=7697e83d&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7697e83d",
  null
  
)

export default component.exports